/* eslint-disable no-async-promise-executor */
import Axios from "axios";
import constant from "../constant";
import api from "../api";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  CREATE_CONTACT: (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Axios.post(
          constant.BASE_URL + api.contact.CREATE_CONTACT(),
          data
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  },
};
